module.exports = new __parcel__URL__("Employee Handbook Hover.94b5de04.svg").toString();